"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = getMembers;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _resolveProfileImages = _interopRequireDefault(require("./resolveProfileImages"));

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function getMembers() {
  return _getMembers.apply(this, arguments);
}

function _getMembers() {
  return _getMembers = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b, c, d) {
    var e, f, g, h, i;
    return _regenerator["default"].wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            return e = b.filter(function (a) {
              var b = a.user,
                  c = a.team;
              return b || c;
            }), f = e.map(function (a) {
              var b = a.user,
                  c = a.team,
                  d = a.role,
                  e = a.resourceRoleAssignmentId;
              return b ? _objectSpread(_objectSpread({}, b), {}, {
                role: d,
                resourceRoleAssignmentId: e
              }) : _objectSpread(_objectSpread({}, c), {}, {
                role: d,
                resourceRoleAssignmentId: e
              });
            }), a.next = 4, (0, _resolveProfileImages["default"])(f, c, d);

          case 4:
            if (g = a.sent, h = g.findIndex(function (a) {
              var b = a.userId,
                  c = a.role;
              return b && "OWNER" === c;
            }), -1 !== h) {
              a.next = 8;
              break;
            }

            return a.abrupt("return", g);

          case 8:
            return i = g.splice(h, 1)[0], g.splice(0, 0, i), a.abrupt("return", g);

          case 11:
          case "end":
            return a.stop();
        }
      }
    }, a);
  })), _getMembers.apply(this, arguments);
}